import {ErrorMessage} from 'components/common/ErrorMessage'
import {Ventrata} from 'types'
import {CartItems} from '../ThankYou/Left/Left'
import {Right} from './Right/Right'

type Props = {
  order: Ventrata.Order
  error: Error | any
}

export const ConfirmingProblem = ({order, error}: Props) => {
  return (
    <div className="flex flex-col gap-8">
      <div className="font-bold text-[32px]">Something went wrong</div>
      <ErrorMessage error={error} />
      <div className="font-bold text-2xl">Order summary</div>

      <div className="flex flex-col d:flex-row justify-between">
        <CartItems order={order} />
        <Right order={order} />
      </div>
    </div>
  )
}
